"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "text-box" };
const _hoisted_2 = { class: "title" };
const _hoisted_3 = { class: "text" };
const _hoisted_4 = {
    key: 0,
    class: "ml-auto"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
    key: 1,
    class: "price-block"
};
const _hoisted_7 = { class: "price" };
const _hoisted_8 = { class: "text" };
const CustomInput_vue_1 = __importDefault(require("../../components/frontend/CustomInput.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'DetailWideRadio',
    props: {
        name: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "",
        },
        text: {
            type: String,
            default: "",
        },
        img: {
            type: String,
            default: "",
        },
        price: {
            type: Number,
            default: 0,
        },
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", {
                class: (0, vue_2.normalizeClass)(["tire-detail-radio-wide", { 'tire-fitting-detail-radio-wide': __props.price !== 0 }])
            }, [
                (0, vue_2.createVNode)(CustomInput_vue_1.default, {
                    class: "input-box",
                    type: "radio",
                    name: __props.name,
                    value: __props.name
                }, null, 8, ["name", "value"]),
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)(__props.title), 1),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)(__props.text), 1)
                ]),
                (__props.img)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                        (0, vue_2.createElementVNode)("img", {
                            src: require(`../../images/frontend/${__props.img}`)
                        }, null, 8, _hoisted_5)
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                (__props.price !== 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, [
                        (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)(__props.price) + " Ft", 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)(_ctx.$trans("per_tyre", "per tire", "frontend_service_block")), 1)
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 2));
        };
    }
});
